// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ant-layout {
  background: #fff !important;
}
.ant-form-item-children {
  display: inline-block;
  width: 100%;
}
.ant-steps-item-active {
  font-weight: 600;
}
.ant-menu-inline {
  height: calc(100% - 65px);
}
#rev-pay .ant-col-offset-2 {
  margin-left: -78.33%;
}
#user_step_container {
  max-width: 400px;
  left: -250px;
}
#is_blocked {
  margin: 0 10px 10px;
}
`, "",{"version":3,"sources":["webpack://./src/App.less"],"names":[],"mappings":"AAAA;EACE,2BAAA;AACF;AAEA;EACE,qBAAA;EACA,WAAA;AAAF;AAGA;EACE,gBAAA;AADF;AAIA;EACE,yBAAA;AAFF;AAKA;EACI,oBAAA;AAHJ;AAMA;EACI,gBAAA;EACA,YAAA;AAJJ;AAOA;EACI,mBAAA;AALJ","sourcesContent":[".ant-layout {\n  background: #fff !important;\n}\n\n.ant-form-item-children {\n  display: inline-block;\n  width: 100%;\n}\n\n.ant-steps-item-active {\n  font-weight: 600;\n}\n\n.ant-menu-inline {\n  height: calc(100% - 65px);\n}\n\n#rev-pay .ant-col-offset-2{\n    margin-left: -78.33%;\n}\n\n#user_step_container{\n    max-width: 400px;\n    left:-250px;\n}\n\n#is_blocked{\n    margin:0 10px 10px;\n}\n@border-radius-base: 3px;"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
